// Options for search durations
export const searchDurationsOptions = [
  { width: "w-[67px]", value: 0, name: "اليوم" },
  { width: "w-[92px]", value: 1, name: "آخر اسبوع" },
  { width: "w-[98px]", value: 2, name: "آخر 14 يوم " },
  { width: "w-[88px]", value: 3, name: "آخر  شهر " },
  { width: "w-[103px]", value: 4, name: "آخر 3 شهور " },
  { width: "w-[78px]", value: 5, name: "آخر  عام " },
];

export const dayTranslations = {
  sunday: "الاحد",
  monday: "الاثنين",
  tuesday: "الثلاثاء",
  wednesday: "الاربعاء",
  thursday: "الخميس",
  friday: "الجمعة",
  saturday: "السبت",
};

export const ordersChartColors = ["#16BDCA", "#570094"];

export const clientsLegendItems = [
  { name: "عملاء سابقين" },
  { name: "عملاء جدد" },
];

export const newOrdersLegendItems = [
  { name: "مبيعات لعملاء سابقين" },
  { name: "مبيعات لعملاء جدد" },
];
export const legendItemsC = [
  { name: "IOS" },
  { name: "Android" },
  { name: "آخرى" },
];
export const verificationsLegendItems = [
  { id: "pendingVerificationsPercentage", name: "في انتظار الموافقة " },
  { id: "acceptedVerificationsPercentage", name: "الطلبات المقبولة" },
  { id: "rejectedVerificationsPercentage", name: "الطلبات المرفوضة" },
];

export const pieChartColors = ["#ECBA8E", "#6B33A6", "#6CBDCA"];
